import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  card: {
    margin: '10px 0px',
  },
  main: {
    margin: '10px',
  },
  maintitle: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'black',
  },
  titles: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'black',
  },
}));

export default useStyles;
